import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { EmbedContainer } from "./common-container";
import { loadData } from "../loadData";
import { withLocale } from "../utils/locale";
import { Header, PoweredByScoopIt } from "./common-header";
import { Description, Insight, LinkImage, Meta, Title } from "./common-posts";
const ReactMultiCarousel = require("react-multi-carousel").default;

export const DEFAULT_SECTIONS = ["media", "meta", "title"];
export const AVAILABLE_SECTIONS = ["media", "meta", "title", "content", "insight"];

const CarouselRenderer = ({
    data,
    maxPosts,
    locale,
    displayHeader = true,
    sections = DEFAULT_SECTIONS,
    disableEmbeds,
    colSplitWidth,
    minCols = 1,
    maxCols = 8,
    displayPoweredByScoopIt = true,
}) => {
    dayjs.locale(locale);
    const ref = useRef();
    const [cols, setCols] = useState(0);
    const [maxWidth, setMaxWidth] = useState(null);
    useEffect(() => {
        const computeCols = () => {
            const elt = ref.current;
            const width = elt.offsetWidth;
            const nCols = Math.min(Math.max(Math.round(width / (colSplitWidth || 400)), minCols), maxCols);
            if (nCols != cols) {
                setCols(nCols);
            }
            // Note: this trick does not work when downsizing.
            setMaxWidth(width);
        }
        window.addEventListener("resize", computeCols);
        computeCols();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", computeCols);
    });
    if (cols === 0) {
        // render nothing at first, si we can compute the number of columns
        return <div ref={ref}>&nbsp;</div>
    }
    const style = {}
    // force max width after container size has been computed by useEffect
    if (maxWidth != null) {
        style.maxWidth = maxWidth;
    }
    return <EmbedContainer ref={ref}>
        <div className="scp-overflow-hidden scp-max-w-none" style={style}>
            <ReactMultiCarousel
                additionalTransfrom={0}
                arrows
                autoPlay
                autoPlaySpeed={3000}
                centerMode={false}
                className=""
                containerClass="container-with-dots scp-box-border"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={{
                    handledByMe: {
                        breakpoint: {
                            max: 4000,
                            min: 0
                        },
                        items: cols
                    },
                }}
                showDots={false}
                sliderClass=""
                slidesToSlide={2}
                swipeable
            >
                {
                    data.posts.map((post, i) => (!maxPosts || maxPosts > i) && <CarouselPost
                        post={post}
                        sections={sections}
                        disableEmbeds={disableEmbeds}
                        key={i}
                    />)
                }
            </ReactMultiCarousel>
        </div>
        {displayPoweredByScoopIt && <PoweredByScoopIt />}

    </EmbedContainer>
}



const CarouselPost = ({ sections, post, disableEmbeds }) => {
    const displayEmbed = post.html_embed && !disableEmbeds;
    return <div
        className="scp-p-4 scp-rounded-sm scp-shadow-md scp-embed-block scp-embed-post-container scp-flex scp-flex-col scp-gap-2 scp-overflow-hidden scp-m-2 scp-box-border"
        // scp-m-2 == 1rem
        style={{ height: "calc(100% - 1rem)" }}
    >
        {sections.map((section, i) => {
            switch (section) {
                case "title":
                    return <Title href={post.url} key={i}>{post.title}</Title>;
                case "media":
                    return <CarouselPostImage post={post} key={i} />;
                case "meta":
                    return <Meta {...post} key={i} />;
                case "content":
                    return <Description dangerouslySetInnerHTML={{ __html: post.html_content }} key={i} />;
                case "insight":
                    return <Insight {...post} key={i} />;
            }

        })
        }

    </div >
}

const CarouselPostImage = ({ post }) => post.image_url && <div className="scp-relative scp-h-0" style={{ paddingBottom: "56.25%" }}>
    <LinkImage
        href={post.url}
        target="blank"
        className="scp-w-full scp-h-full scp-absolute scp-top-0 scp-left-0"
        src={post.image_url}
    />
</div>

export const Carousel = loadData(withLocale(CarouselRenderer));
